(() => {
  const init = () => {
    document.querySelectorAll('.i4-navigation:not([data-ready])').forEach(nav => {
      nav.dataset.ready = 'true';
      const desktop = window.matchMedia('(min-width: 750px)');
      const hover = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      const controllers = new Map();
      nav.querySelectorAll('[data-i4-branch]').forEach(branch => {
        const row = branch.querySelector(':scope > .i4-nav-label, :scope > .i4-menu-row');
        const button = row?.querySelector('button');
        const panel = button && document.getElementById(button.getAttribute('aria-controls'));
        if (button && panel) controllers.set(branch, { button, panel, timer: null });
      });
      const closeBranch = branch => {
        const controller = controllers.get(branch);
        if (!controller) return;
        clearTimeout(controller.timer);
        branch.removeAttribute('data-open');
        controller.button.setAttribute('aria-expanded', 'false');
        branch.querySelectorAll('[data-i4-branch]').forEach(closeBranch);
      };
      const closeAll = () => nav.querySelectorAll('.i4-menu-item[data-open]').forEach(closeBranch);
      const placePanel = branch => {
        if (!desktop.matches) return;
        const { panel } = controllers.get(branch);
        const viewportWidth = document.documentElement.clientWidth;
        const viewportHeight = window.innerHeight;
        const row = branch.querySelector(':scope > .i4-nav-label, :scope > .i4-menu-row').getBoundingClientRect();
        panel.style.setProperty('--i4-panel-height', `${viewportHeight - 24}px`);
        const panelWidth = panel.getBoundingClientRect().width;
        let left = row.left;
        let top = row.bottom;
        if (!branch.classList.contains('i4-menu-item')) {
          const ancestorPanel = branch.parentElement.closest('.i4-mega, .i4-submenu');
          const parentBounds = ancestorPanel.getBoundingClientRect();
          const right = parentBounds.right - 1;
          const openLeft = right + panelWidth > viewportWidth - 12 && parentBounds.left >= panelWidth + 12;
          left = openLeft ? parentBounds.left - panelWidth + 1 : right;
          branch.dataset.side = openLeft ? 'left' : 'right';
          const height = Math.min(panel.scrollHeight, viewportHeight - 24);
          top = Math.min(row.top - 10, viewportHeight - height - 12);
        }
        left = Math.max(12, Math.min(left, viewportWidth - panelWidth - 12));
        top = Math.max(12, Math.min(top, viewportHeight - 92));
        panel.style.setProperty('--i4-panel-left', `${left}px`);
        panel.style.setProperty('--i4-panel-top', `${top}px`);
        panel.style.setProperty('--i4-panel-height', `${viewportHeight - top - 12}px`);
      };
      const openBranch = branch => {
        const controller = controllers.get(branch);
        if (!controller) return;
        clearTimeout(controller.timer);
        [...branch.parentElement.children].forEach(sibling => {
          if (sibling !== branch && controllers.has(sibling)) closeBranch(sibling);
        });
        branch.setAttribute('data-open', '');
        controller.button.setAttribute('aria-expanded', 'true');
        placePanel(branch);
      };
      controllers.forEach((controller, branch) => {
        controller.button.addEventListener('click', event => {
          const open = hover.matches && event.detail > 0 ? true : !branch.hasAttribute('data-open');
          if (open) openBranch(branch); else closeBranch(branch);
        });
        branch.addEventListener('pointerenter', event => {
          clearTimeout(controller.timer);
          if (hover.matches && event.pointerType !== 'touch') openBranch(branch);
        });
        branch.addEventListener('pointerleave', () => {
          if (hover.matches) controller.timer = setTimeout(() => closeBranch(branch), 220);
        });
        branch.addEventListener('focusin', event => {
          if (desktop.matches && !branch.contains(event.relatedTarget)) openBranch(branch);
        });
        branch.addEventListener('focusout', event => {
          if (!branch.contains(event.relatedTarget)) closeBranch(branch);
        });
        controller.panel.addEventListener('scroll', () => {
          branch.querySelectorAll('[data-i4-branch][data-open]').forEach(closeBranch);
        }, { passive: true });
      });
      nav.addEventListener('keydown', event => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const row = target.closest('.i4-nav-label, .i4-menu-row');
        const branch = row?.parentElement;
        if (event.key === 'Escape') {
          const current = target.closest('[data-i4-branch][data-open]');
          if (!current) return;
          event.preventDefault();
          closeBranch(current);
          controllers.get(current)?.button.focus();
          return;
        }
        if (controllers.has(branch) && (event.key === 'ArrowRight' || event.key === 'ArrowDown' && branch.classList.contains('i4-menu-item'))) {
          event.preventDefault();
          openBranch(branch);
          controllers.get(branch).panel.querySelector('a')?.focus();
          return;
        }
        const list = target.closest('.i4-submenu, .i4-mega-list');
        if (!list) return;
        if (event.key === 'ArrowLeft' && list.classList.contains('i4-submenu')) {
          event.preventDefault();
          closeBranch(list.parentElement);
          controllers.get(list.parentElement)?.button.focus();
          return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const links = [...list.children].map(item => item.querySelector(':scope > a, :scope > .i4-menu-row > a')).filter(Boolean);
        const index = links.indexOf(target);
        if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links[next]?.focus();
      });
      const mobileButton = nav.querySelector('.i4-mobile-toggle');
      mobileButton?.addEventListener('click', () => {
        const open = mobileButton.getAttribute('aria-expanded') !== 'true';
        mobileButton.setAttribute('aria-expanded', String(open));
        document.getElementById(mobileButton.getAttribute('aria-controls'))?.classList.toggle('is-open', open);
        if (!open) closeAll();
      });
      document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) closeAll(); });
      desktop.addEventListener('change', closeAll);
      window.addEventListener('resize', closeAll);
      window.addEventListener('scroll', closeAll, { passive: true });
    });
    document.querySelectorAll('[data-i4-finder]:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const data = document.querySelector('[data-i4-vehicles]');
      if (!data) return;
      let config;
      try { config = JSON.parse(data.textContent); } catch { return; }
      const brand = form.querySelector('[data-i4-brand]');
      const model = form.querySelector('[data-i4-model]');
      if (!brand || !model) return;
      const fill = (select, label, options) => {
        select.replaceChildren(new Option(label, ''));
        options.forEach(option => select.add(new Option(option.label, option.handle)));
      };
      const brandLabel = brand.options[0].text;
      const modelLabel = model.options[0].text;
      const previousBrand = brand.value;
      fill(brand, brandLabel, Object.keys(config.brands).map(label => ({ label, handle: label })));
      if (config.brands[previousBrand]) brand.value = previousBrand;
      const updateModels = () => {
        const models = config.brands[brand.value]?.models || [];
        fill(model, modelLabel, models);
        model.disabled = models.length === 0;
      };
      brand.addEventListener('change', updateModels);
      updateModels();
      form.addEventListener('submit', event => {
        event.preventDefault();
        const selectedBrand = config.brands[brand.value];
        if (!selectedBrand) { brand.focus(); return; }
        const selectedModel = selectedBrand.models.find(item => item.handle === model.value);
        if (!selectedModel) { model.focus(); return; }
        window.location.assign(`${config.collectionsUrl}/${encodeURIComponent(selectedModel.handle)}`);
      });
    });
    document.querySelectorAll('[data-i4-slider]:not([data-ready])').forEach(slider => {
      slider.dataset.ready = 'true';
      const slides = [...slider.querySelectorAll('[data-i4-slide]')];
      const dots = [...slider.querySelectorAll('[data-i4-dot]')];
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; slide.classList.toggle('is-active', i === current); });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        slides[current].animate([{ opacity: 0 }, { opacity: 1 }], { duration: 1000, easing: 'ease-in-out' });
      }
};
      slider.querySelector('[data-i4-prev]')?.addEventListener('click', () => show(current - 1));
      slider.querySelector('[data-i4-next]')?.addEventListener('click', () => show(current + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      slider.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') show(current + 1);
        if (event.key === 'ArrowLeft') show(current - 1);
      });
          if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.setInterval(() => {
          if (slider.isConnected && !document.hidden && !slider.matches(':hover, :focus-within')) show(current + 1);
        }, 3000);
      }
});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
